import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../styles/pageStyles/CreateChannel.scss'
import Cropper from 'react-easy-crop'
import { v4 as uuidv4 } from 'uuid';
import getCroppedImg from '../resources/GetCroppedImg';
import axios from 'axios';
import { BASE_URL } from '../api/api';
import { useCookies } from 'react-cookie';
import { getUploadSignedUrl, getViewSignedUrl } from '../api/s3Service';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// File uploader 
import { useDropzone } from 'react-dropzone';

import { WithContext as ReactTags } from 'react-tag-input';
import { Auth } from '../context/Auth';

const CreateChannel = () => {
    const [channelDetails, setChannelDetails] = useState({ channelLogo: [], channelFinalLogo: "", channelName: "", channelHandle: "", channelId: "", description: "", category: "", ownerInterest: [], chatPrice: 0 });

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [classForChannelHandleInput, setClassForChannelHandleInput] = useState(false);

    const notifyNoLogo = () => toast("⚠️ Upload logo for your channel");
    const notifyChannelHandleExists = () => toast("⚠️ Channel Handle Already Exists");

    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn']);

    const auth = useContext(Auth)

    const navigate = useNavigate();

    const onDrop = useCallback(acceptedFiles => {
        setChannelDetails({
            ...channelDetails, channelLogo: acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
        });
    }, [channelDetails]);
    console.log(channelDetails, "channel details");

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    // tags library code Start
    const KeyCodes = {
        comma: 188,
        enter: 13,
    };
    const delimiters = [KeyCodes.comma, KeyCodes.enter];

    const handleDelete = (i) => {
        setChannelDetails({ ...channelDetails, ownerInterest: channelDetails.ownerInterest.filter((tag, index) => index !== i) });
    };

    const handleAddition = (tag) => {
        setChannelDetails({ ...channelDetails, ownerInterest: [...channelDetails.ownerInterest, tag] });
    };

    const handleDrag = (tag, currPos, newPos) => {
        const newTags = channelDetails.ownerInterest.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        setChannelDetails({ ...channelDetails, ownerInterest: newTags });
    };

    const handleTagClick = (index) => {
        console.log('The tag at index ' + index + ' was clicked');
    };
    // tags library code END

    // Set Logo
    useEffect(() => {
        if (channelDetails.channelLogo.length !== 0) {
            if (channelDetails.channelLogo[0].name.substring(channelDetails.channelLogo[0].name.lastIndexOf('.') + 1).toLowerCase() === 'jpg' || 'png' || 'jpeg') {
                setChannelDetails({ ...channelDetails, channelFinalLogo: channelDetails.channelLogo[0].preview });
            }
        }
    }, [channelDetails.channelLogo]);

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        console.log(croppedArea, croppedAreaPixels);
        setCroppedAreaPixels(croppedAreaPixels);
        showCroppedImage(croppedAreaPixels);
    }

    const showCroppedImage = async (cropAreaPix) => {
        try {
            const croppedImage = await getCroppedImg(
                channelDetails.channelLogo[0].preview,
                cropAreaPix,
            )
            console.log('donee', croppedImage);
            setChannelDetails({ ...channelDetails, channelFinalLogo: croppedImage });

            const imageUrl = URL.createObjectURL(croppedImage);

            const imgElement = document.getElementById('croppedImage');
            imgElement.src = imageUrl;
        } catch (e) {
            console.error(e);
        }
    }

    const handleCropChange = (crop) => {
        setCrop(crop);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log(channelDetails, "channel Details under form")

        //Check if User uploded the logo
        if (channelDetails.channelFinalLogo === "") {
            notifyNoLogo();
        } else {
            // check if Channel Handle Already Exists
            await axios.get(`${BASE_URL}/api/channels/check-existing-handle/${channelDetails.channelHandle}`).then(res => {
                if (res.data.doesChannelExist) {
                    notifyChannelHandleExists();
                    window.scrollTo(0, 250);
                    setClassForChannelHandleInput(true);
                } else {
                    // finally submit the form 
                    submitForm();
                }

            }).catch(err => console.log(err));
        }

    }

    async function submitForm() {
        const uniqueLogoID = uuidv4();
        const key = uniqueLogoID + channelDetails.channelLogo[0].name.replace(/\s+/g, '');
        const contentType = channelDetails.channelLogo[0].type;
        console.log(key, contentType);

        // Get S3 URL
        const uploadedLogoUrl = await getUploadSignedUrl(key, contentType);
        console.log(channelDetails.channelFinalLogo, "channelDetails.channelFinalLogo,")
        await axios.put(uploadedLogoUrl, channelDetails.channelFinalLogo, {
            headers: {
                'Content-Type': contentType,
            },
        }).then(res => {
            console.log(res);
            if (res.statusText === "OK") {
                storeFileUrlToDB(key);
                // alert('File uploaded successfully');
            }
        }).catch(err => console.log(err))


        async function storeFileUrlToDB(key) {
            const logoURL = await getViewSignedUrl(key);
            createChannel(logoURL);
            console.log(logoURL, "logoURL");
        }

        async function createChannel(logoURL) {
            // Generate UniqueID for channel
            const uniqueChannelID = uuidv4();
            setChannelDetails({ ...channelDetails, channelId: uniqueChannelID });

            // Here update User,"channelId" parameter in database and then fetch the channelId from User. Store this Id in the cookies or localStorage for further use
            const formData = {
                logo: logoURL,
                channelName: channelDetails.channelName,
                channelHandle: channelDetails.channelHandle,
                channelId: uniqueChannelID,
                about: channelDetails.description,
                ownerUserId: cookies.userId,
                chatPrice: "0"
            }

            console.log(formData, "form data");
            //create channel api integration
            await axios.post(`${BASE_URL}/api/channels/`, formData)
                .then(res => {
                    console.log(res);
                    if (res.data.statusText === "success") {
                        navigate(`/my-channel/${formData.channelHandle}?id=${formData.channelId}`);
                        auth.authReducerDispatch({ type: "updateChannelId", payload: { channelId: res.data.user.channelId } });
                        // setCookie('channelId', formData.channelId, { path: '/' });
                        console.log(res, "Channel Created Success!");
                    }
                })
                .catch(err => console.log(err))
        }
    }

    // console.log(channelDetails);
    return (
        <div className='create-channel'>
            <h2 className='create-channel__main-header'>Create Your Channel</h2>
            <div className="create-channel__container">
                <form action="" onSubmit={handleFormSubmit}>
                    <div className="create-channel__input-group">
                        <label className='create-channel__label'>Upload Logo</label>
                        {
                            channelDetails.channelLogo.length === 0 && <div className='create-channel__logo-upload-area'> <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                {
                                    isDragActive ?
                                        <p>Drag 'n' drop Logo here,<br /> or <br /> Click to upload</p> :
                                        <p>Drag 'n' drop Logo here,<br />  or <br /> Click to Upload</p>
                                }
                            </div>
                            </div>
                        }

                        {
                            channelDetails.channelLogo.length !== 0 &&
                            <div className='create-channel__logo-main-container'>
                                <div className="create-channel__thumbnail-cropper-container">
                                    <Cropper
                                        image={channelDetails.channelLogo[0].preview}
                                        crop={crop}
                                        zoom={zoom}
                                        showGrid={true}
                                        aspect={1 / 1}
                                        cropShape={'round'}
                                        onCropComplete={onCropComplete}
                                        onCropChange={handleCropChange}
                                        onZoomChange={setZoom}
                                    />
                                </div>
                                <div className='create-channel__logo-container'>
                                    <h5>Your Channel Logo</h5>
                                    <img id="croppedImage" className='create-channel__cropped-logo' alt="cropped logo" />
                                </div>
                            </div>
                        }

                        {
                            channelDetails.channelLogo.length !== 0 && <>
                                {
                                    channelDetails.channelLogo.length !== 0 && <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        {
                                            channelDetails.channelLogo.length !== 0 && <div className='create-channel__change-file-btn'>Change Logo</div>

                                        }
                                    </div>
                                }
                            </>
                        }
                    </div>

                    <div className="create-channel__input-group">
                        <label className='create-channel__label' htmlFor="channel-name">Channel Name</label>
                        <input className='create-channel__input' id='channel-name' type="text" maxLength={50} value={channelDetails.channelName} onChange={(e) => setChannelDetails({ ...channelDetails, channelName: e.target.value })} placeholder='Give name to your channel' required />
                    </div>

                    <div className="create-channel__input-group">
                        <label className='create-channel__label' htmlFor="channel-handle">Channel Handle</label>
                        <input className={classForChannelHandleInput ? 'create-channel__input create-channel__input--border' : 'create-channel__input'} id='channel-handle' type="text" maxLength={100} value={channelDetails.channelHandle} onChange={(e) => { setChannelDetails({ ...channelDetails, channelHandle: e.target.value }); setClassForChannelHandleInput(false) }} placeholder='Create unique channel handle' required />
                        {
                            classForChannelHandleInput && <span className='create-channel__error-msg'>Handle already taken. Create another channel handle.</span>
                        }

                    </div>

                    <div className="create-channel__input-group">
                        <label className='create-channel__label' htmlFor="channel-description">About</label>
                        <textarea className='create-channel__input' id='channel-description' rows={10} cols={30} maxLength={500} value={channelDetails.description} onChange={(e) => setChannelDetails({ ...channelDetails, description: e.target.value })} placeholder=' Write short description about your channel' required />
                    </div>

                    {/* <div className="create-channel__input-group">
                        <label className='create-channel__label' htmlFor="channel-chat-price">Chat Price : &#x20B9; {channelDetails.chatPrice}</label>
                        <input className='create-channel__input' id='channel-chat-price' type='range' min={0} max={5000} step={10} value={channelDetails.chatPrice} onChange={(e) => setChannelDetails({ ...channelDetails, chatPrice: e.target.value })} required />
                    </div> */}
                    {/* <div className="create-channel__input-group">
                        <label className='create-channel__label' htmlFor="channel-category">Category</label>
                        <select className='create-channel__input' id='channel-category' value={channelDetails.category} onChange={(e) => setChannelDetails({ ...channelDetails, category: e.target.value })}>
                            <option value="" disabled required>Select From List</option>
                            <option value="agriculture">Agriculture</option>
                            <option value="arts">Arts and Humanities</option>
                            <option value="banking">Banking</option>
                            <option value="biology">Biology</option>
                            <option value="business">Business and Management</option>
                            <option value="coding">Coding</option>
                            <option value="chemistry">Chemistry</option>
                            <option value="defence">Defence</option>
                            <option value="digital currencies">Digital Currencies</option>
                            <option value="engineering">Engineering</option>
                            <option value="entrepreneurship">Entrepreneurship</option>
                            <option value="gaming">Gaming</option>
                            <option value="health and wellness">Health and Wellness</option>
                            <option value="internet of things">Internet of Things (IoT)</option>
                            <option value="law and legal studies">Law and Legal Studies</option>
                            <option value="marketing">Marketing</option>
                            <option value="mathematics">Mathematics</option>
                            <option value="medical">Medical</option>
                            <option value="programming">Programming</option>
                            <option value="physics">Physics</option>
                            <option value="software engineering">Software Engineering</option>
                            <option value="teaching">Teaching</option>
                            <option value="travel and tourism">Travel and Tourism</option>
                            <option value="other">Other</option>
                        </select>
                    </div> */}

                    {/* <div className="create-channel__input-group">
                        <label className='create-channel__label' htmlFor="channel-interest">My Interest</label>
                        <div className="create-channel__tags">
                            <ReactTags
                                tags={channelDetails.ownerInterest}
                                // suggestions={suggestions}
                                delimiters={delimiters}
                                handleDelete={handleDelete}
                                handleAddition={handleAddition}
                                handleDrag={handleDrag}
                                handleTagClick={handleTagClick}
                                inputFieldPosition="bottom"
                                maxTags={10}
                                maxLength={30}
                                autocomplete
                            />
                        </div>
                    </div> */}

                    <button type='submit' className="create-channel__submit-btn">Create</button>
                </form>
            </div>
        </div>
    )
}

export default CreateChannel